import clsx from 'clsx';
import { MarkOptional } from 'ts-essentials';
import Tabs, { TabsProps } from 'components/tabs';
import BaseScreen, { BaseScreenProps } from 'components/base-screen';
import styles from './styles.module.scss';

export type TabsScreenProps = Pick<TabsProps, 'tabs' | 'onTabChange' | 'defaultTab'> &
  MarkOptional<BaseScreenProps, 'children'>;

const TabsScreen: React.FC<TabsScreenProps> = (props) => {
  const { tabs, padContent, onTabChange, children, defaultTab, ...rest } = props;
  return (
    <BaseScreen {...rest}>
      <Tabs
        tabs={tabs}
        onTabChange={onTabChange}
        tabsContainerClassName={styles.tabs}
        contentClassName={clsx(styles.content, padContent && styles.paddedContent)}
        defaultTab={defaultTab}
      >
        {children}
      </Tabs>
    </BaseScreen>
  );
};

export default TabsScreen;
